import { useContext } from 'react';

import { DndContext } from './dnd-context';

function useDnd() {
  return useContext(DndContext);
}

export { useDnd };
